import { ReactNode } from "react";

export default function MobileContainer({children}: {children: ReactNode}){
    return (
        <main id="mo-container">{children}</main>
    )
}